import { useSortable } from "@dnd-kit/sortable"
import { CSS } from "@dnd-kit/utilities"
import WeeklyObjectivesCard from "./weekly-objectives-card"
import type {
  WeeklyObjective,
  WeeklyOfWeekly as Column,
} from "../../entities/weekly-objectives/weekly-objectives"

interface WeeklyObjectivesCardSortableProps {
  weeklyObjective: WeeklyObjective
  displayObjective?: () => void
  areDragging: boolean
  isPending: boolean
  sourceColumn: Column | null
  isAnOldColumn: boolean
}

export default function WeeklyObjectivesCardSortable({
  weeklyObjective,
  displayObjective,
  areDragging,
  isPending,
  sourceColumn,
  isAnOldColumn,
}: WeeklyObjectivesCardSortableProps) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: weeklyObjective.id,
  })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  }

  const isFromAnotherColumn = Boolean(
    sourceColumn &&
    !sourceColumn.objectives.some((objective) => objective.id === weeklyObjective.id),
  )

  return (
    <div ref={setNodeRef} style={style}>
      <WeeklyObjectivesCard
        {...weeklyObjective}
        dragAttributes={attributes}
        dragListeners={listeners}
        displayObjective={displayObjective}
        isPending={isPending}
        canHideCard={areDragging && isFromAnotherColumn}
        isAnOldColumn={isAnOldColumn}
      />
    </div>
  )
}
